export const PROFILE_TYPE = {
    SUPER_ADMIN: 90,
    INTEGRATOR: 95,
    INTEGRATOR_TECHNICIAN_G1: 96,
    INTEGRATOR_TECHNICIAN_G2: 97
}